import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ApplicationInsights, IExceptionTelemetry, SeverityLevel } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';
import { appConfig } from 'src/app/models/constants';

@Injectable({
    providedIn: 'root',
})
export class ApplicationInsightsService {
    
    private appInsights : ApplicationInsights;

    constructor(private router: Router) {
      if (appConfig.appConfigService?.appInsights?.enable) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: appConfig.appConfigService?.appInsights?.instrumentationKey,
          enableCorsCorrelation : true,
          enableRequestHeaderTracking: false,
          // v3 uses 'pagehide'/'visibilitychange' instead; 'unload' is blocked by the Permissions-Policy header.
          disablePageUnloadEvents: ['unload'],
          extensionConfig: {
            // v3 fetches feature/throttle settings from js.monitor.azure.com by default, which our CSP connect-src blocks.
            AppInsightsCfgSyncPlugin: { blkCdnCfg: true }
          }
        }
      });
  
      this.appInsights.loadAppInsights();
      this.loadCustomTelemetryProperties();
      this.createRouterSubscription();
    }
  }
  
    setUserIdContext(userId: string, accountId: string, storeInCookie: boolean) {
      this.appInsights.setAuthenticatedUserContext(userId, accountId, storeInCookie);
    }

    setUserId(userId: string) {
      this.appInsights.setAuthenticatedUserContext(userId);
    }
  
    setAccountId(accountId: string) {
      this.appInsights.setAuthenticatedUserContext(undefined, accountId);
    }
  
    clearUserId() {
      this.appInsights.clearAuthenticatedUserContext();
    }

    trackEvent(arg0: { name: string; properties: { Component: string; Username: string; }; }) {
      this.appInsights.trackEvent(arg0);
    }

    trackTrace(arg0: { message: string;}) {
      this.appInsights.trackTrace(arg0);
    }
  
    logPageView(name?: string, uri?: string, properties?: any, measurements?: any) {
      this.appInsights.trackPageView({ name, uri, properties, measurements});
    }
  
    logException(error : Error){
      let exception : IExceptionTelemetry = {
        exception : error
      };
      this.appInsights.trackException(exception);
    }
  
    private loadCustomTelemetryProperties()
    {
      this.appInsights.addTelemetryInitializer(envelope => 
        {
          if (envelope.baseType == 'MessageData') {
          var item = envelope.baseData;
          item.properties = item.properties || {};
          //item.properties["Username"] = JSON.stringify(item.userName);
         // item.properties["clientName"] = JSON.stringify(item.clientName);
         // console.log(item.properties["Username"]);
          //this.appInsights.setAuthenticatedUserContext(item.properties["Username"], item.properties["clientName"], true);
      }
    }
      );
    }
  
    private createRouterSubscription()
    {
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.logPageView(null, event.urlAfterRedirects);
      });
    }
  }